import { Injectable } from '@angular/core';
import { Platform, UserAgent } from '@rd/types';
import * as Bowser from 'bowser';
import { WindowRefService } from '../window-ref/window-ref.service';

@Injectable({
  providedIn: 'root',
})
export class UserAgentService {
  constructor(private windowRef: WindowRefService) {}

  public checkUserAgent(): UserAgent {
    const ua = this.windowRef.nativeWindow.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1;

    if (iOS && webkit && !ua.match(/CriOS/i)) {
      return 'iOSSafari';
    } else if (iOS && webkit) {
      return 'iOS';
    } else if (isSafari) {
      return 'desktopSafari';
    } else {
      return 'browser';
    }
  }

  public getPlatFormType(): Platform {
    return this.currentBrowser().getPlatformType();
  }

  public currentBrowser(): any {
    return Bowser.getParser(navigator.userAgent);
  }
}
